if(!customElements.get('contact-us')){
    customElements.define('contact-us', class ContactUs extends HTMLElement {
        constructor() {
            super();
            this.closeButton = this.querySelector('.footer-contact-popup__close');
            this.openButton = document.querySelector('.link-contact-us a');
            this.closeSuccessPopup = this.querySelector('.close-button');
            this.emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            this.phoneRegex = /^[0-9\-]*$/;
            this.name = this.querySelector('#ContactForm-name');
            this.firstNameInput = this.querySelector('#ContactForm-first-name');
            this.lastNameInput = this.querySelector('#ContactForm-last-name');
            this.emailInput = this.querySelector('#ContactForm-email');
            this.phoneInput = this.querySelector('#ContactForm-phone');
            this.subjectInput = this.querySelector('#ContactForm-subject');
            this.submitForm = this.querySelector('form');
            this.submitButton = document.querySelector('.footer-contact-popup .button');
            this.errorMessage = document.querySelector('.error-message');
            this.formElements = document.querySelectorAll('.form-element');
            this.successMessage = document.querySelector('.success-message');
            this.openButton && this.openButton.addEventListener('click', this.open.bind(this));
            this.closeButton && this.closeButton.addEventListener('click', this.close.bind(this));
            this.closeSuccessPopup && this.closeSuccessPopup.addEventListener('click', this.closeSuccess.bind(this));
            this.firstNameInput && this.firstNameInput.addEventListener('keyup', this.checkFirstName.bind(this));
            this.lastNameInput && this.lastNameInput.addEventListener('keyup', this.checkFirstName.bind(this));
            this.submitForm && this.submitForm.addEventListener('submit', this.submit.bind(this));
            this.showPopup();
        }
        showPopup() {
            console.log('showPopup');
            const windowUrl = window.location.href;
            if(windowUrl.includes('?contact_posted=true')){
                this.style.display = 'flex';
            }
        }
        submit(event) {
            event.preventDefault();
            console.log('submit');
            this.errorMessage.classList.remove('error');
            if(!this.firstNameInput.value || !this.lastNameInput.value){
                this.errorMessage.querySelector('p').innerHTML = 'Please enter your first and last name.';
                this.errorMessage.classList.add('error');
                return;
            }
            if(!this.emailInput.value || !this.emailRegex.test(this.emailInput.value)){
                this.errorMessage.querySelector('p').innerHTML = 'Please enter a valid email address.';
                this.errorMessage.classList.add('error');
                return;
            }
            if(!this.phoneInput.value || !this.phoneRegex.test(this.phoneInput.value)){
                this.errorMessage.querySelector('p').innerHTML = 'Please enter a valid phone number.';
                this.errorMessage.classList.add('error');
                return;
            }
            if(!this.subjectInput.value){
                this.errorMessage.querySelector('p').innerHTML = 'Please enter a subject.';
                this.errorMessage.classList.add('error');
                return;
            }
            this.submitForm.submit();
        }
        open(event) {
            console.log(event);
            event.preventDefault();
            window.history.replaceState({}, '', window.location.pathname);
            this.style.display = 'flex';
            this.formElements.forEach(element => {
                element.classList.remove('hidden');
            });
            this.successMessage.classList.add('hidden');
        }
        close() {
            window.history.replaceState({}, '', window.location.pathname);
            this.style.display = 'none';
            this.formElements.forEach(element => {
                element.classList.remove('hidden');
            });
            this.successMessage.classList.add('hidden');
        }
        closeSuccess(event) {
            window.history.replaceState({}, '', window.location.pathname); ///?contact_posted=true#ContactForm
            this.close();
        }
        checkFirstName() {
            this.name.value = this.firstNameInput.value + " " + this.lastNameInput.value;
        }
    });
}